import CharmsInfoSchema from '../schema/CharmsInfoSchema';
import charmsInfoStore from '../store';
import KeywordInfo from '../schema/KeywordInfo';
import { select } from 'satcheljs/lib/legacy';

export interface GetCalendarCharmsInfo {
    charmStore: CharmsInfoSchema;
}

export let getKeywordInfo = select({
    charmStore: () => charmsInfoStore,
})(function getKeywordInfo(keywordKey: string, state?: GetCalendarCharmsInfo): KeywordInfo {
    var store = state.charmStore;
    if (keywordKey != null && keywordKey.length > 0 && store != null && store.keywordsMap != null) {
        return store.keywordsMap.get(keywordKey.toLocaleLowerCase());
    }

    return null;
});

export default getKeywordInfo;
